module.exports = __webpack_public_path__ + "static/transparenttextlogo-64ef8a90891055a50b1fd960815639d8.svg";